import { useEffect, useLayoutEffect } from 'react';

/**
 * On the server useLayoutEffect is a no-op and React emits a warning.
 * This hook switches to useEffect during SSR so the warning is suppressed,
 * while preserving the synchronous before-paint behaviour on the client.
 */
export const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
